module.exports = __webpack_public_path__ + "static/media/eyeWideRight.76ee82e7.obj";